import React, {
  useEffect,
  useState,
} from "react";

import {
  fetchCategoryInsights,
  formatApiError,
} from "../services/api";

function PriceHeatmap({
  onCategoryClick,
}) {

  // =====================================================
  // STATES
  // =====================================================

  const [
    categoryData,
    setCategoryData,
  ] = useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  // =====================================================
  // LOAD CATEGORY DATA
  // =====================================================

  useEffect(() => {

    loadCategoryData();

  }, []);

  const loadCategoryData =
    async () => {

      try {

        setLoading(true);

        const response =
          await fetchCategoryInsights();

        setCategoryData(
          response.data || []
        );

      } catch (err) {

        console.error(
          "CATEGORY API ERROR:",
          err
        );

        setError(
          formatApiError(err)
        );

      } finally {

        setLoading(false);
      }
    };

  // =====================================================
  // CARD TYPE
  // =====================================================

  const getCardClass = (
    cheaper,
    expensive
  ) => {

    if (cheaper > expensive) {

      return "category-main-card";
    }

    if (expensive > cheaper) {

      return (
        "category-main-card danger-card"
      );
    }

    return "category-main-card";
  };

  // =====================================================
  // BADGE TYPE
  // =====================================================

  const getBadgeClass = (
    cheaper,
    expensive
  ) => {

    if (cheaper > expensive) {

      return "ratio-badge cheaper";
    }

    if (expensive > cheaper) {

      return "ratio-badge expensive";
    }

    return "ratio-badge neutral";
  };

  // =====================================================
  // BADGE TEXT
  // =====================================================

  const getBadgeText = (
    cheaper,
    expensive
  ) => {

    if (cheaper > expensive) {

      return "F2B Better";
    }

    if (expensive > cheaper) {

      return "Competitor Better";
    }

    return "Balanced";
  };

  // =====================================================
  // LOADING
  // =====================================================

  if (loading) {

    return (

      <div className="heatmap-loading">

        Loading Category Insights...

      </div>
    );
  }

  // =====================================================
  // ERROR
  // =====================================================

  if (error) {

    return (

      <div className="heatmap-error">

        {error}

      </div>
    );
  }

  // =====================================================
  // RENDER
  // =====================================================

  return (

    <div className="heatmap-container">

      {/* =============================================
          HEADER
      ============================================= */}

      <div className="section-header">

        <div>

          <h2>
            Category Price Insights
          </h2>

          <p>
            Category-wise pricing
            intelligence and
            competitiveness analysis
          </p>

        </div>

      </div>

      {/* =============================================
          GRID
      ============================================= */}

      <div className="heatmap-grid">

        {categoryData.map(
          (item, index) => {

            const totalProducts =

              item.totalProducts ||
              item.total_products ||
              0;

            const cheaperCount =

              item.f2bCheaper ||
              item.f2b_cheaper ||
              0;

            const expensiveCount =

              item.f2bExpensive ||
              item.f2b_expensive ||
              0;

            const cheaperPercent =

              totalProducts > 0

                ? (
                    cheaperCount /
                    totalProducts
                  ) * 100

                : 0;

            const isDanger =

              expensiveCount >
              cheaperCount;

            return (

              <div
                key={index}
                className={getCardClass(
                  cheaperCount,
                  expensiveCount
                )}
                onClick={() =>
                  onCategoryClick(
                    item.category,
                    item.products || []
                  )
                }
              >

                {/* =================================
                    TOP ROW
                ================================= */}

                <div className="card-top-row">

                  <h3>
                    {item.category}
                  </h3>

                  <div
                    className={getBadgeClass(
                      cheaperCount,
                      expensiveCount
                    )}
                  >

                    {getBadgeText(
                      cheaperCount,
                      expensiveCount
                    )}

                  </div>

                </div>

                {/* =================================
                    STATS
                ================================= */}

                <div className="heatmap-stats">

                  {/* CHEAPER */}

                  <div className="stat-box">

                    <div className="stat-label">

                      F2B Cheaper

                    </div>

                    <div
                      className="stat-value cheaper-val"
                    >

                      {cheaperCount}

                    </div>

                  </div>

                  {/* EXPENSIVE */}

                  <div className="stat-box">

                    <div className="stat-label">

                      F2B Expensive

                    </div>

                    <div
                      className="stat-value expensive-val"
                    >

                      {expensiveCount}

                    </div>

                  </div>

                </div>

                {/* =================================
                    PROGRESS BAR
                ================================= */}

                <div className="card-progress-bar">

                  <div
                    className={
                      isDanger

                        ? "card-progress-fill danger-fill"

                        : "card-progress-fill"
                    }
                    style={{
                      width:
                        `${cheaperPercent}%`,
                    }}
                  />

                </div>

                {/* =================================
                    FOOTER
                ================================= */}

                <div
                  style={{
                    display: "flex",
                    alignItems:
                      "center",
                    justifyContent:
                      "space-between",
                  }}
                >

                  <div className="view-text">

                    View Products

                  </div>

                  <div className="card-total">

                    Total:
                    {" "}
                    {totalProducts}

                  </div>

                </div>

              </div>

            );
          }
        )}

      </div>

    </div>
  );
}

export default PriceHeatmap;